import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

export const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
    // Defer so route's <Helmet> can update document.title first
    const t = window.setTimeout(() => trackPageView(pathname + search), 50);
    return () => window.clearTimeout(t);
  }, [pathname, search, navType]);

  return null;
};
